export enum RouteKey {
  paymentOptions = 'paymentOptions',
  travelerDetails = 'travelerDetails',
  additionalDetails = 'additionalDetails',
  payment = 'payment',
  status = 'status',
}

export const sortedAllRoutes: Route[] = [
  { key: RouteKey.paymentOptions, path: '/orders/payment-options' },
  { key: RouteKey.travelerDetails, path: '/orders/traveller-details' },
  { key: RouteKey.additionalDetails, path: '/orders/additional-details' },
  { key: RouteKey.payment, path: '/orders/payment' },
  { key: RouteKey.status, path: '/orders/booking-status' },
]

export type Route = {
  key: RouteKey
  path: string
}

export type AvailableRoute = Route & {
  isEnabled: boolean
}
